export const getTime = () => {
    const d = new Date();
    const hours = ('0' + (d.getHours() % 12)).slice(-2);
    const minutes = ('0' + d.getMinutes()).slice(-2);
    const seconds = ('0' + d.getSeconds()).slice(-2);
    return `${hours}:${minutes}:${seconds}`;
};
export default getTime;
//# sourceMappingURL=getTime.js.map